module.exports = __webpack_public_path__ + "a6eda20c98ca05e6d51e7afc770503d9.svg";